'use client';

import { useIsMobile } from '@/hooks/is-mobile';
import { useFeatureFlags } from '@/hooks/state/feature-flags';
import { themeUtils } from '@/utils/mobile';
import { ThemeProvider as NextThemesProvider, useTheme } from 'next-themes';
import { useSearchParams } from 'next/navigation';
import { ReactNode, useEffect } from 'react';

type ThemeProviderProps = {
  children: ReactNode;
};

const MobileThemeOverride = ({ children }: { children: ReactNode; }): React.JSX.Element => {
  const { data: featureFlags } = useFeatureFlags();
  const { isMobile } = useIsMobile();
  const searchParams = useSearchParams();
  const { setTheme } = useTheme();

  useEffect(() => {
    if (isMobile && featureFlags?.theme?.enableMobileThemeSelection) {
      const mobileTheme = themeUtils.getThemeFromParams(searchParams);
      if (mobileTheme) {
        setTheme(mobileTheme);
      }
    }
  }, [featureFlags, isMobile, searchParams, setTheme]);

  return <>{children}</>;
};

export const ThemeProvider = ({ children }: ThemeProviderProps): React.JSX.Element => {
  return (
    <NextThemesProvider disableTransitionOnChange
      attribute="class"
      defaultTheme="light"
      enableSystem={false}
      storageKey="cinemark-theme-preference"
    >
      <MobileThemeOverride>{children}</MobileThemeOverride>
    </NextThemesProvider>
  );
};
